$(".hamburger").click(function () {
	$(this).toggleClass("active");
	$(".nav_menu").toggleClass('active');
	$("body").toggleClass("active");
});



$(function() {
	$('.flower_slider').slick({
		autoplay: true,
		centerMode: true,
		centerPadding: '0px',
		slidesToShow: 3,
		prevArrow: '<button class="slide-arrow prev-arrow"></button>',
		nextArrow: '<button class="slide-arrow next-arrow"></button>',
		responsive: [{
			breakpoint: 992, // 399px以下のサイズに適用
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '20px',
				slidesToShow: 1,
				dots: true,
			},
		}, ],
	});
});

$(function () {
	if (window.matchMedia('(max-width: 720px)').matches) {
		$(function () {
			//クリックで動く
			$('.ac_ttl').click(function () {
				$(this).toggleClass('active');
				$(this).next('.ac_inner').slideToggle();
			});
		});
	}
})
